
import * as z from 'zod';

export const productFormSchema = z.object({
  name: z.string().min(3, { message: 'Product name must be at least 3 characters' }),
  description: z.string().min(10, { message: 'Description must be at least 10 characters' }),
  category: z.string().min(1, { message: 'Category is required' }),
  subcategory: z.string().min(1, { message: 'Subcategory is required' }),
  buyPrice: z.string().refine(val => !isNaN(Number(val)) && Number(val) > 0, {
    message: 'Buy price must be a positive number',
  }),
  sellPrice: z.string().refine(val => !isNaN(Number(val)) && Number(val) > 0, {
    message: 'Sell price must be a positive number',
  }),
  discount: z.string().optional(),
  couponCode: z.string().optional(),
});

export type ProductFormValues = z.infer<typeof productFormSchema>;
